import React from 'react';

const drpark_exam = [
    {
        id: 1,
        name: 'http://dongalaw.org',
        title: '"Dong-A Law School CBT System"',
        publisher: 'for Laptops(Mac compatible)',
        year: '2023.11.'
    },
    {
        id: 2,
        name: 'Ministry of Justice',
        title: '"13th Bar Exam Committee Member"',
        publisher: 'Grading Committee',
        year: '2024.2.'
    },
    {
        id: 3,
        name: 'Ministry of Justice',
        title: '"14th Bar Exam Committee Member"',
        publisher: 'Drafting Committee',
        year: '2025.1.'
    },
    {
        id: 4,
        name: 'https://www.drpark.kr/#/barpass_predictor',
        title: '"Bar Exam First-Time Pass Predictor"',
        publisher: 'for DALS students',
        year: '2026.5.'
    }
]



function Exam() {

    return (
        <ol>
            {drpark_exam.slice(0).reverse().map(ex => (
                <li>{ex.name}, {ex.title}, {ex.publisher}, {ex.year}</li>
            ))}
        </ol>
    );
}

export default Exam;
